import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api } from "../../../api/ApiCall";

export const getDrawingQuestions = createAsyncThunk(
  "getDrawingQuestions",
  async (drawing_id) => {
    const request = await api(`api/admin/questionsforui/${drawing_id}`, "", "get");
    return request;
  }
);

export const saveAnswers = createAsyncThunk(
  "saveAnswers",
  async (data) => {
    const request = await api(`api/admin/questions/answers/${data.drawing_id}`, data, "post");
    return request;
  }
);

const drawingQuestionsSlice = createSlice({
  name: "drawingQuestionsSlice",
  initialState: {
    loading: false,
    success: null,
    error: null,
    totalCount: 0,
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getDrawingQuestions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDrawingQuestions.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.message;
        state.error = null;
      })
      .addCase(getDrawingQuestions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(saveAnswers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveAnswers.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(saveAnswers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});
export default drawingQuestionsSlice.reducer;
